import { gql } from '@apollo/client';

export const GET_JUDGMENTS = gql`
    query lp_read($options: read_options, $region: Region!, $type: DeLp_Type!) {
        lp_read(options: $options, region: $region, type: $type) {
            message
            ok
            status
            total_count
            error {
                message
                path
            }
            data {
                judgement {
                    judgement_id
                    case_id
                    justice_id
                    body_judgement
                    judgement_type
                    ratio_dec_id
                }
            }
        }
    }
`;

export const CURRENT_JUDGEMENTS = gql`
    query {
        current_judgements
    }
`;

export const GET_JUDGEMENT_TYPE = gql`
    query lp_read($options: read_options, $region: Region!, $type: DeLp_Type!) {
        lp_read(options: $options, region: $region, type: $type) {
            message
            ok
            status
            total_count
            error {
                message
                path
            }
            data {
                judgement_types {
                    type_id
                    judgement_type
                    description
                }
            }
        }
    }
`;
